import { action } from 'typesafe-actions';

import { TransportCardPlaceInterface, TransportCardsPlaceTypes } from './types';

// List Transport Cards Place
export const listTransportCardsPlaceRequest = (payload: object) =>
  action(TransportCardsPlaceTypes.LIST_TRANSPORT_CARDS_PLACE_REQUEST, payload);

export const listTransportCardsPlaceSuccess = (payload: {
  transportCardsPlaceList: TransportCardPlaceInterface[];
  totalCount: number;
}) =>
  action(TransportCardsPlaceTypes.LIST_TRANSPORT_CARDS_PLACE_SUCCESS, payload);

export const listTransportCardsPlaceFailure = () =>
  action(TransportCardsPlaceTypes.LIST_TRANSPORT_CARDS_PLACE_FAILURE);

// Get Transport Cards Place
export const getTransportCardsPlaceRequest = (payload: object) =>
  action(TransportCardsPlaceTypes.GET_TRANSPORT_CARDS_PLACE_REQUEST, payload);

export const getTransportCardsPlaceSuccess = (payload: {
  transportCardsPlaceData: TransportCardPlaceInterface;
}) =>
  action(TransportCardsPlaceTypes.GET_TRANSPORT_CARDS_PLACE_SUCCESS, payload);

export const getTransportCardsPlaceFailure = () =>
  action(TransportCardsPlaceTypes.GET_TRANSPORT_CARDS_PLACE_FAILURE);

// Filter Transport Cards Place
export const filterTransportCardsPlaceRequest = (payload: object) =>
  action(
    TransportCardsPlaceTypes.FILTER_TRANSPORT_CARDS_PLACE_REQUEST,
    payload,
  );

export const filterTransportCardsPlaceSuccess = (payload: {
  transportCardsPlaceList: TransportCardPlaceInterface[];
  totalCount: number;
}) =>
  action(
    TransportCardsPlaceTypes.FILTER_TRANSPORT_CARDS_PLACE_SUCCESS,
    payload,
  );

export const filterTransportCardsPlaceFailure = () =>
  action(TransportCardsPlaceTypes.FILTER_TRANSPORT_CARDS_PLACE_FAILURE);

// Create Transport Cards Place
export const createTransportCardsPlaceRequest = (payload: object) =>
  action(
    TransportCardsPlaceTypes.CREATE_TRANSPORT_CARDS_PLACE_REQUEST,
    payload,
  );

export const createTransportCardsPlaceSuccess = (payload: {
  transportCardsPlaceData: TransportCardPlaceInterface;
}) =>
  action(
    TransportCardsPlaceTypes.CREATE_TRANSPORT_CARDS_PLACE_SUCCESS,
    payload,
  );

export const createTransportCardsPlaceFailure = () =>
  action(TransportCardsPlaceTypes.CREATE_TRANSPORT_CARDS_PLACE_FAILURE);

// Update Transport Cards Place
export const updateTransportCardsPlaceRequest = (payload: object) =>
  action(
    TransportCardsPlaceTypes.UPDATE_TRANSPORT_CARDS_PLACE_REQUEST,
    payload,
  );

export const updateTransportCardsPlaceSuccess = () =>
  action(TransportCardsPlaceTypes.UPDATE_TRANSPORT_CARDS_PLACE_SUCCESS);

export const updateTransportCardsPlaceFailure = () =>
  action(TransportCardsPlaceTypes.UPDATE_TRANSPORT_CARDS_PLACE_FAILURE);

// Delete Transport Cards Place
export const deleteTransportCardsPlaceRequest = (payload: object) =>
  action(
    TransportCardsPlaceTypes.DELETE_TRANSPORT_CARDS_PLACE_REQUEST,
    payload,
  );

export const deleteTransportCardsPlaceSuccess = () =>
  action(TransportCardsPlaceTypes.DELETE_TRANSPORT_CARDS_PLACE_SUCCESS);

export const deleteTransportCardsPlaceFailure = () =>
  action(TransportCardsPlaceTypes.DELETE_TRANSPORT_CARDS_PLACE_FAILURE);
